import type { PageBlockApiModel } from '@gro-up/api/corporate'

export type CorporateRowSettings = {
  anchor?: string | null
}

/**
 * Read the anchor an editor configured on a grid row, to use as the section's `id`.
 *
 * The raw value is kept as-is (only trimmed and stripped of a leading `#`): the backend appends
 * the very same string to the link URL, so normalising it on one side only would make links and
 * their targets drift apart.
 */
export const getBlockAnchorId = (block: Pick<PageBlockApiModel, 'settings'>): string | undefined => {
  const anchor = (block.settings as CorporateRowSettings | null | undefined)?.anchor

  if (typeof anchor !== 'string') {
    return undefined
  }

  return anchor.trim().replace(/^#+/, '') || undefined
}
